import {
  chatTypeSchema,
  ChatType,
  QualifiedChatId,
} from "@zeemee/react-web-chat";

export const QualifiedChatIdSerializer = {
  serialize: (qualifiedChatId?: QualifiedChatId | null): string | undefined => {
    const { chatType, chatId } = qualifiedChatId ?? {};
    return chatType && chatId ? `${chatType}-${chatId}` : undefined;
  },
  deserialize: (value?: string | null): QualifiedChatId | undefined => {
    const [, type, id] = value?.match(/^(chat|groupchat)-(.+)$/) || [];
    const chatTypeParseResult = chatTypeSchema.safeParse(type);

    if (!chatTypeParseResult.success || !id) {
      return undefined;
    }

    return {
      chatType: chatTypeParseResult.data as ChatType,
      chatId: id,
    };
  },
};
